export default __webpack_public_path__ + "static/media/AdobeStock_238195812.853228a9.jpg";